import { Select, Slider, InputNumber, Tooltip, DatePicker } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { useFilterOptions } from "../../hooks/useFilterOptions";
import AppliedFilters from "./components/AppliedFilters";
import Constants from "../../Constants";
import MonthPickerComponent from "../../Utils/MonthPickerComponent";

const Filters = ({ resetDataHandler, onApplyFilters, setFilters, filters = {}, setViewMode }) => {
    const [filtersVal, setFiltersVal] = useState({});
    const [finType, setFinType] = useState(0);
    const { tagOptions, investorOptions, refreshInvestors } = useFilterOptions({ loadTags: true });
    const [openDropdown, setOpenDropdown] = useState("");
    const [expandedCategories, setExpandedCategories] = useState({
        companyProfile: true,
        dealFilters: false,
        financialsFilters: false
    });
    const [showAppliedFilters, setShowAppliedFilters] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState({});

    // Sync filtersVal with parent filters when a saved screener is loaded
    useEffect(() => {
        if (filters && Object.keys(filters).length > 0) {
            setFiltersVal(filters);
            setAppliedFilters(filters);
            // setShowAppliedFilters(true);
        }
    }, [filters]);
    const { Industries, Sectors, setSectors, AllCities, Rounds, getSectorByIndustry } = useContext(PeFilterContext);
    // console.log(Industries, "Industries")


    const filterConfigs = {
        companyProfile: {
          tag: { label: "Tag", type: "multiSelect", values: tagOptions, labelKey: "name", valueKey: "name", searchBox: true, searchType: true, className: "lg:min-w-[250px] lg:row-start-1 lg:col-start-1" },
        industry: { label: "Industry", type: "multiSelect", values: Industries, labelKey: "name", valueKey: "id", searchBox: true, className: "lg:min-w-[250px] lg:row-start-2" },
        sector: { label: "Sector", type: "multiSelect", values: Sectors, labelKey: "name", valueKey: "id", searchBox: true, className: "lg:min-w-[250px] lg:row-start-2" },
        city: { label: "City", type: "multiSelect", values: AllCities, labelKey: "name", valueKey: "id", searchBox: true, className: "lg:min-w-[250px] lg:row-start-2" },
        },

        financialsFilters: {
          revenue: {
              label: "Revenue (₹Cr)",
              type: "range",
              defaultValues: [1, 500],
          },
              ebitda: {
              label: "EBITDA (₹Cr)",
              type: "range",
              defaultValues: [1, 500],
          },
              pat: {
              label: "PAT (₹Cr)",
              type: "range",
              defaultValues: [1, 500],
          },
            // sliderFilters: {
            
            revenueGrowth: {
                label: "Revenue Growth (%)",
                type: "number",
                defaultValues: [0, 100],
                className: "lg:row-start-2 lg:col-start-1"
            },
            ebitdaGrowth: {
                label: "EBITDA Growth (%)",
                type: "number",
                defaultValues: [0, 100],
                className: "lg:row-start-2 lg:col-start-2"
            },
            patGrowth: {
                label: "PAT Growth (%)",
                type: "number",
                defaultValues: [0, 100],
                className: "lg:row-start-2 lg:col-start-3"
            },
            operatingMargin: {
                label: "Operating Margin (%)",
                type: "number",
                defaultValues: [0, 100],
                className: "lg:row-start-3 lg:col-start-1"
            },
            contributionMargin: {
                label: "Contribution Margin (%)",
                type: "number",
                defaultValues: [0, 100],
                className: "lg:row-start-3 lg:col-start-2"
            },
            // },
        },

        dealFilters: {
            investors: { label: "Investors", type: "multiSelect", values: investorOptions, labelKey: "name", valueKey: "id", searchBox: true, apiSearch: true, onApiSearch: refreshInvestors, searchType: true },
            latestRound: { label: "Latest Round", type: "multiSelect", values: Rounds, labelKey: "name", valueKey: "name", searchBox: false },
            company_valuation: { label: "Company Valuation (₹Cr)", type: "range", defaultValues: [1, 500], className: "lg:min-w-[270px] lg:row-start-2 lg:col-start-1"},
            // dealAmount: { label: "Latest Deal Amount ($M)", type: "range" },
            date_range: { label: "Deal Date", type: "dateRange"}
        },

    };



    const filterChangeHandler = (key, value) => {
        console.log(key, value, "onchange val")
        // For object values (like slider with {operator, value}), check if value.value is null
        if (typeof value === 'object' && value !== null && !Array.isArray(value) && (value.value === null || value.value === undefined)) {
            setFiltersVal((prev) => {
                const newState = { ...prev };
                delete newState[key];
                return newState;
            });
        } else {
            setFiltersVal((prev) => ({
                ...prev,
                [key]: value
            }));
        }
    }

    const getCurrentValue = (key, defaultValues) => {
        return filtersVal[key] || defaultValues;
    }

    // When industries change, fetch sectors for selected industry IDs.
    // Prevent repeated calls by comparing with previous selection.
    const prevIndustryIdsRef = useRef([]);
    useEffect(() => {
      const ids = Array.isArray(filtersVal.industry) ? filtersVal.industry : [];
      const prevIds = prevIndustryIdsRef.current || [];
      const normalize = (arr) => (Array.isArray(arr) ? [...arr].sort() : []);
      const changed = normalize(ids).join(",") !== normalize(prevIds).join(",");

      if (ids.length > 0) {
        if (changed) {
          prevIndustryIdsRef.current = ids;
          getSectorByIndustry(ids, "investments");
        }
      } else {
        // Clear sectors when no industry selected
        prevIndustryIdsRef.current = [];
        setSectors([]);
      }
    }, [filtersVal.industry]);

    // console.log(filtersVal, "selected filter vals");

    const toggleCategory = (categoryKey) => {
        setExpandedCategories(prev => {
            const newState = {
                companyProfile: false,
                dealFilters: false,
                financialsFilters: false
            };
            // If the clicked category is currently closed, open it
            // If it's already open, keep it closed (toggle behavior)
            newState[categoryKey] = true;
            return newState;
        });
    };

    const renderFiltersByCategory = () => {
        const categoryTitles = {
            companyProfile: "Co. Profile",
            financialsFilters: "Financials",
            dealFilters: "Investor", 
        };

        const fintypetoggle = () => {
          
          const fintypeChangeHandler = (value) => {
            setFinType(value);
          }

          return (
            <>
              <div className="flex bg-white rounded-xs border p-0.5 mr-2 text-center">
                {finType === 1 ?
                <>
                  <Tooltip placement="bottom" title="Switch To Standalone View">
                    <div
                      className={`w-24 p-3 py-1 text-xs bg-white
                        transition-all duration-200 delay-200`}
                    >
                      <button onClick={() => fintypeChangeHandler(0)}>Standalone</button>
                    </div>
                  </Tooltip>
                  <div
                    className={`w-24 p-3 py-1 text-xs border-r border-gray-500 ${
                      finType === 1 ? "bg-[#595959] rounded-xs text-[#f2cf82]" : "bg-white"
                    }  transition-all duration-200 delay-200`}
                  >
                    <button>Consolidated</button>
                  </div>
                </> :
                <>
                  <div
                    className={`w-24 p-3 py-1 text-xs ${
                      finType === 0 ? "bg-[#595959] rounded-xs text-[#f2cf82]" : "bg-white"
                    }  transition-all duration-200 delay-200`}
                  >
                    <button>Standalone</button>
                  </div>
                  <Tooltip placement="bottom" title="Switch To Consolidated View">
                    <div
                      className={`w-24 p-3 py-1 text-xs bg-white
                        transition-all duration-200 delay-200`}
                    >
                      <button onClick={() => fintypeChangeHandler(1)}>Consolidated</button>
                    </div>
                  </Tooltip>
                  </>}
              </div>
            </>
          )
        }

        const getActiveCategory = () => {
            return Object.entries(expandedCategories).find(([key, value]) => value)?.[0];
        };

        const activeCategory = getActiveCategory();
        const activeCategoryFilters = [];

        if (activeCategory) {
            const category = filterConfigs[activeCategory];
            Object.entries(category).map(([key, config]) => {
                    activeCategoryFilters.push(
                        <FilterRenderer
                            key={key}
                            filterKey={key}
                            config={config}
                            value={filtersVal[key]}
                            operatorValue={filtersVal[`${key}_operator`]}
                            onChange={filterChangeHandler}
                            openDropdown={openDropdown}
                            setOpenDropdown={setOpenDropdown}
                        />
                    );
                // }
            });
        }

        const applyFilterHandler = (filters) => {
          setViewMode("filter")
          const filtersWithFintype = { ...filters, fin_type: finType };
          setFilters(filtersWithFintype);
          onApplyFilters(filtersWithFintype); 
          setAppliedFilters(filtersWithFintype);
          setShowAppliedFilters(Object.keys(filters).length > 0);
        };

        const resetFiltersHandler = () =>{
          setFiltersVal({}); 
          resetDataHandler();
          setAppliedFilters({});
        }

        const removeFilter = (key) => {
            const newFilters = { ...filtersVal };
            delete newFilters[key];
            setFiltersVal(newFilters);
            setAppliedFilters(newFilters);
            onApplyFilters(newFilters);
            if (Object.keys(newFilters).length === 0) {
                setShowAppliedFilters(false);
            }
        };

        const editFilters = () => {
            setShowAppliedFilters(!showAppliedFilters);
        };

        return (
              <div className="p-2 mx-2 bg-white rounded-xl">
                <div className={`flex flex-wrap items-center mb-1 ${showAppliedFilters ? "gap-2" : "gap-16"} relative`}>
                    {showAppliedFilters ? <AppliedFilters appliedFilters={appliedFilters} removeFilter={removeFilter} editFilters={editFilters} /> : (
                      
                          <div className="px-8 w-[12%] flex flex-col items-start gap-2 border-r border-[#595959] border-opacity-30">
                              {/* Screener */}
                              <div className="absolute -rotate-45 z-[150] h-[1.2rem] px-4 mt-3 bg-red-600 text-white -left-3 -top-1 rounded flex items-center">
                                <h3 className="tracking-widest font-semibold text-xs ">BETA</h3>
                              </div>
                              <div className="px-3 py-1">
                                <p className="text-lg font-semibold">Screener</p>
                              </div>
                              {Object.entries(filterConfigs).map(([categoryKey, category]) => (
                                  <div
                                      key={categoryKey}
                                      className={`flex items-center justify-center cursor-pointer px-3 py-1 rounded text-sm font-medium transition-all duration-200 ${
                                          expandedCategories[categoryKey] 
                                              ? 'bg-[#595959] text-[#f2cf82]' 
                                              : 'text-gray-600'
                                      }`}
                                      onClick={() => toggleCategory(categoryKey)}
                                  >
                                      {categoryTitles[categoryKey]}
                                  </div>
                              ))}
                              
                          </div>
                    )}
                  {/* Active Category Content */}
                  {!showAppliedFilters && activeCategory && (
                    <div className="grid grid-cols-4 lg:gap-[1rem_2rem] lg:w-4/5">
                      {activeCategoryFilters}
                      {activeCategory === "financialsFilters" && (
                        <div className="row-start-1 col-start-4 flex justify-end items-baseline">
                          {fintypetoggle()}
                        </div>
                      )}
                      <div className={`${activeCategory === "financialsFilters" ? "row-start-3" : "row-start-2"} col-start-4 self-end flex gap-2 justify-end`}>
                        <button
                          className="px-4 py-1.5 text-xs bg-white text-gray-600 rounded hover:bg-gray-200 border border-[#696969]"
                          onClick={() => resetFiltersHandler()}
                        >
                          Reset
                        </button>

                        <button
                          className="px-4 py-1.5 text-xs bg-[#595959] text-[#f2cf82] rounded hover:bg-[#474747]"
                          onClick={() => applyFilterHandler(filtersVal)}
                        >
                          Apply
                        </button>
                      </div>

                    </div>
                  )}
                </div>
              </div>
        );
    };


  return (
    <div className="">
        {renderFiltersByCategory()}
    </div>
  );
};

export default Filters;


export const FilterRenderer = ({ filterKey, config, value, operatorValue, onChange, openDropdown, setOpenDropdown }) => {
  const currentValue = value || config.defaultValues;

  const ITEMS_PER_LOAD = 50;

  const [searchText, setSearchText] = useState("");
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_LOAD);
  const [isSearching, setIsSearching] = useState(false);
  const loaderRef = useRef(null);
  const dropdownRef = useRef(null);
  const containerRef = useRef(null);
  const searchTimeoutRef = useRef(null);
  const { RangePicker } = DatePicker
  
  // Generic option mapper to handle varying shapes
  const mapOptions = (items = []) => {
    return items?.map((item) => ({
      label:
        (config?.labelKey && item?.[config.labelKey]) ??
        item?.label ??
        item?.name ??
        item?.cityName ??
        item?.value ??
        String(item),
      value:
        (config?.valueKey && item?.[config.valueKey]) ??
        item?.value ??
        item?.id ??
        item?.cityId ??
        item?.code ??
        item,
    }));
  };

  // MultiSelect specific logic
  const multiSelectOptions = config.type === "multiSelect" ? mapOptions(config.values || []) : [];
  const selectedValues = value || [];
  const isDropdownOpen = openDropdown === filterKey;
  
  // Filter options based on search text
  const filteredOptions = config.type === "multiSelect" ? 
    multiSelectOptions.filter((option) => 
      option.label.toLowerCase().includes(searchText.toLowerCase())
    ) : [];
  
  // Get visible options for virtualization
  const visibleOptions = config.type === "multiSelect" ? filteredOptions.slice(0, visibleCount) : [];
  const hasMoreData = config.type === "multiSelect" ? visibleCount < filteredOptions.length : false;
  
  // IntersectionObserver for loading more items - only for multiSelect
  useEffect(() => {
    if (config.type !== "multiSelect" || !isDropdownOpen || !hasMoreData) return;
    
    const observer = new IntersectionObserver(
      (entries) => {
        const first = entries[0];
        if (first.isIntersecting && hasMoreData) {
          setVisibleCount(prev => Math.min(prev + ITEMS_PER_LOAD, filteredOptions.length));
        }
      },
      { 
        root: dropdownRef.current,
        threshold: 0.1,
        rootMargin: '50px'
      }
    );

    const currentLoader = loaderRef.current;
    if (currentLoader && hasMoreData) {
      observer.observe(currentLoader);
    }

    return () => {
      if (currentLoader) {
        observer.unobserve(currentLoader);
      }
    };
  }, [config.type, isDropdownOpen, hasMoreData, filteredOptions.length]);
  
  // Reset visible count when search changes - only for multiSelect
  useEffect(() => {
    if (config.type === "multiSelect") {
      setVisibleCount(ITEMS_PER_LOAD);
    }
  }, [searchText, config.type]);

  // Debounced API search for filters with apiSearch enabled
  useEffect(() => {
    if (config.type === "multiSelect" && config.apiSearch && config.onApiSearch) {
      // Clear previous timeout
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }

      // Only search if there's text (minimum 2 characters)
      if (searchText.trim().length >= 2) {
        setIsSearching(true);
        searchTimeoutRef.current = setTimeout(() => {
          config.onApiSearch(searchText).finally(() => {
            setIsSearching(false);
          });
        }, 500); // 500ms debounce
      }

      return () => {
        if (searchTimeoutRef.current) {
          clearTimeout(searchTimeoutRef.current);
        }
      };
    }
  }, [searchText]);

  // Close dropdown when clicking outside
  useEffect(() => {
    if (config.type !== "multiSelect" || openDropdown !== filterKey) return;

    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpenDropdown("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [config.type, openDropdown, filterKey, setOpenDropdown]);

  
  switch (config.type) {
    case "number":
      // Handle slider value structure: { operator: '>', value: 50 } or just number for backward compatibility
      const sliderValue = currentValue?.value !== undefined ? currentValue.value : (Array.isArray(currentValue) ? currentValue[0] : config.defaultValues[0]);
      const sliderOperator = currentValue?.operator || 'gte';
      
      const operatorOptions = [
        { label: '>', value: 'gte' },
        { label: '=', value: 'eq' },
        { label: '<', value: 'lte' },
      ];

      const handleSliderChange = (newValue) => {
        onChange(filterKey, {
          operator: sliderOperator,
          value: newValue
        });
      };

      const handleOperatorChange = (newOperator) => {
        onChange(filterKey, {
          operator: newOperator,
          value: sliderValue
        });
      };

      return (
        <div className={`${config.className} p-2 border border-gray-200 rounded transition-all duration-200 hover:border-slate-900`}>
          <div className="flex items-center justify-between gap-1 mb-1">
            <span className="text-xs font-medium text-gray-700 truncate" title={config.label}>{config.label}</span>
            <div className="flex items-center justify-end gap-2">
              <select
                value={sliderOperator}
                onChange={(e) => handleOperatorChange(e.target.value)}
                className="w-8 text-center text-base font-bold border border-gray-300 rounded px-1 py-0.5 bg-white focus:border-slate-900 focus:outline-none appearance-none"
              >
                {operatorOptions.map(option => (
                  <option key={option.value} value={option.value} className="font-medium">
                    {option.label}
                  </option>
                ))}
              </select>
              <InputNumber value={sliderValue} onChange={handleSliderChange} className="flex-1 text-xs w-10" size="medium" style={{ fontSize: '12px' }} controls={false} />
              {/* <span className="px-1 py-0.5 bg-gray-100 rounded text-gray-700 font-medium text-xs">
                {sliderValue}%
              </span> */}
            </div>
          </div>
          {/* <div className="flex justify-between items-center text-xs text-gray-500">
            <span className="px-1 py-0.5 bg-gray-100 rounded text-gray-700 font-medium">
              {config.defaultValues[0]}
            </span>
            <Slider
              min={config.defaultValues[0]}
              max={config.defaultValues[1]}
              value={sliderValue}
              defaultValue={config.defaultValues}
              onChange={handleSliderChange}
              className="mx-1 inline-block w-3/5 shadow-none fill-slate-600"
              style={{ margin: '0 4px', color: "slategrey" }}
            />
            <span className="px-1 py-0.5 bg-gray-100 rounded text-gray-700 font-medium">
              {config.defaultValues[1]}
            </span>
          </div> */}
        </div>
      );

    case "range":
      return (
        <div className={`${config.className} p-2 bg-white border border-gray-200 rounded transition-all duration-200 hover:border-slate-900`}>
          <div className="text-xs font-medium text-gray-700 truncate flex justify-between gap-1 items-center" title={config.label}>
            {config.label}
            <div className="flex gap-1 w-28">
              <InputNumber
                placeholder="Min"
                value={value?.[0]}
                onChange={(val) => onChange(filterKey, [val, value?.[1]])}
                className="flex-1 text-xs"
                size="medium"
                style={{ fontSize: '12px' }}
                controls={false}
              />
              <InputNumber
                placeholder="Max"
                value={value?.[1]}
                onChange={(val) => onChange(filterKey, [value?.[0], val])}
                className="flex-1 text-xs"
                size="medium"
                style={{ fontSize: '12px' }}
                controls={false}
              />
            </div>
          </div>
        </div>
      );

    case "select":
      const selectOptions = mapOptions(config.values || []);
      
      return (
        <div className="p-1.5 bg-white border border-gray-200 rounded transition-all duration-200 hover:border-slate-900">
          <div className="text-xs font-medium text-gray-700 mb-1 truncate" title={config.label}>
            {config.label}
          </div>
          <div className="max-h-24 overflow-y-auto space-y-0.5">
            {selectOptions.length === 0 && (
              <div className="text-xs text-gray-500">No options</div>
            )}
            {selectOptions.map((option) => (
              <label key={option.value} className="flex items-center cursor-pointer hover:bg-gray-50 p-0.5 rounded">
                <input
                  type="radio"
                  name={filterKey}
                  value={option.value}
                  checked={value === option.value}
                  onChange={(e) => onChange(filterKey, parseInt(e.target.value))}
                  className="mr-1 text-black focus:ring-slate-600 w-3 h-3"
                />
                <span className="text-xs text-gray-700">{option.label}</span>
              </label>
            ))}
            {value && (
              <button
                onClick={() => onChange(filterKey, null)}
                className="text-xs text-red-500 hover:text-red-700 underline"
              >
                Clear
              </button>
            )}
          </div>
        </div>
      );

    case "multiSelect":
      const buttonClassName = `flex items-center space-x-[6px] rounded py-[2px] px-[5px] text-[11px] cursor-pointer`;
      const buttonClassNameActive = `light text-[#FFFFFF] bg-[#BC8B20]`;
      const buttonClassNameInactive = `dark text-body-color`;
      const selectedOperator = operatorValue === "and" ? "and" : "or";
      return (
        <div ref={containerRef} className={`${config.className} py-2 bg-white border-gray-200 rounded transition-all duration-200 relative`}>
          {/* <div className="text-xs font-medium text-gray-700 mb-1 flex justify-between items-center">
            <span className="truncate" title={config.label}>{config.label}</span>
          </div> */}
          
          {/* Dropdown Button */}
          <button
            type="button"
            className="w-full h-8 rounded px-2 py-1 text-gray-500 hover:bg-gray-100 text-xs border border-gray-300 text-left flex items-center justify-between"
            onClick={() => setOpenDropdown(isDropdownOpen ? "" : filterKey)}
          >
            <span className="truncate pr-1">
              {selectedValues.length > 0 
                ? `${config.label} - ${selectedValues.length} selected` 
                : `Select ${config.label}`
              }
            </span>
            <div className="flex items-center gap-2">
              {config.searchType && 
                <div className="flex border rounded">
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      onChange(`${filterKey}_operator`, "or");
                    }}
                    className={`${buttonClassName} ${selectedOperator === "or" ? `${buttonClassNameActive}` : `${buttonClassNameInactive}`}`}>
                    OR
                  </span>

                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      onChange(`${filterKey}_operator`, "and");
                    }}
                    className={`${buttonClassName} ${selectedOperator === "and" ? `${buttonClassNameActive}` : `${buttonClassNameInactive}`}`}>
                    AND
                  </span>
                </div>
              }    
              <span className={`transition-transform duration-200 text-xs ${isDropdownOpen ? 'rotate-180' : ''}`}>
                ▼
              </span>
            </div>
          </button>
          {/* {selectedValues.length > 0 && (
            <div className="flex justify-end pt-2 pr-2">
              <button
                onClick={() => onChange(filterKey, [])}
                className="text-xs text-red-500 hover:text-red-700 flex-shrink-0 ml-1 text-right"
                >
                Clear all
              </button>
            </div>
            )} */}

          {/* Dropdown Content */}
          {isDropdownOpen && (
            <div 
              ref={dropdownRef}
              className="absolute z-50 w-64 mt-1 bg-white border border-gray-300 rounded shadow-lg max-h-40 overflow-y-auto"
            >
              <div className="p-1.5 space-y-0.5">
                {config.searchBox && (
                  <div className="sticky top-0 bg-white pb-1 border-b border-gray-100">
                    <input 
                      className="border border-gray-300 rounded p-2 w-full text-xs focus:border-slate-900 focus:outline-none" 
                      type="text" 
                      value={searchText} 
                      onChange={(e) => setSearchText(e.target.value)} 
                      placeholder={config.apiSearch ? "Type to search..." : "Search..."} 
                    />
                    {/* {filteredOptions.length > 0 && !isSearching && (
                      <div className="text-xs text-gray-500 mt-0.5">
                        {Math.min(visibleCount, filteredOptions.length)}/{filteredOptions.length}
                      </div>
                    )} */}
                    {isSearching && (
                      <div className="text-xs text-gray-500 mt-0.5">Searching...</div>
                    )}
                  </div>
                )}

                {config.apiSearch && searchText.length < 2 && multiSelectOptions.length === 0 && (
                  <div className="text-xs text-gray-500 px-1 py-2 text-center">Search For Investors</div>
                )}

                {!config.apiSearch && multiSelectOptions.length === 0 && (
                  <div className="text-xs text-gray-500 px-1">No options</div>
                )}

                {filteredOptions.length === 0 && searchText.length >= 2 && !isSearching && (
                  <div className="text-xs text-gray-500 px-1 py-2 text-center">No results</div>
                )}

                {/* Render visible options */}
                {visibleOptions.map((option) => {
                  const isChecked = selectedValues.includes(option.value);
                  return (
                    <label key={option.value} className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded">
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) => {
                          const newValues = e.target.checked
                            ? [...selectedValues, option.value]
                            : selectedValues.filter(val => val !== option.value);
                          onChange(filterKey, newValues);
                        }}
                        className="mr-1.5 text-black focus:ring-slate-600 w-3 h-3"
                      />
                      <span className="text-xs text-gray-700 truncate">{option.label}</span>
                    </label>
                  );
                })}
                
                {/* Loading indicator */}
                {hasMoreData && (
                  <div 
                    ref={loaderRef} 
                    className="flex items-center justify-center p-1 text-xs text-gray-500"
                  >
                    <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-slate-600 mr-1"></div>
                    Loading...
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      );

    case "dateRange":
      const getLastDayOfMonth = (year, month) => {
        // month is 1-indexed here, so we create date for next month day 0
        return new Date(year, month, 0).getDate();
      };

      const monthMap = {
        'Jan': '01', 'Feb': '02', 'Mar': '03', 'Apr': '04',
        'May': '05', 'Jun': '06', 'Jul': '07', 'Aug': '08',
        'Sep': '09', 'Oct': '10', 'Nov': '11', 'Dec': '12'
      };

      const formatDateRange = (dateStrings) => {
        if (!dateStrings?.[0] || !dateStrings?.[1]) return null;

        const parseMonthYear = (str) => {
          const [mon, yy] = str.split('-');
          const year = 2000 + parseInt(yy); // AntD RangePicker with format "MMM-YY" won't go pre-2000 in practice
          const month = monthMap[mon];
          return { year: parseInt(year), month: parseInt(month) };
        };

        const { year: fromYear, month: fromMonth } = parseMonthYear(dateStrings[0]);
        const { year: toYear, month: toMonth } = parseMonthYear(dateStrings[1]);

        const pad = (n) => String(n).padStart(2, '0');
        const lastDay = getLastDayOfMonth(toYear, toMonth);

        return [
          `${fromYear}-${pad(fromMonth)}-01`,
          `${toYear}-${pad(toMonth)}-${lastDay}`,
        ];
      };

      const disabledDate = (current) => {
        if (!current) return false;
        const minDate = new Date(1998, 0, 1); // 01 Jan 1998
        const maxDate = new Date(); // Current date
        return current < minDate || current > maxDate;
      };

      return (
        <div className="transition-all duration-200 lg:row-start-2 flex items-center gap-6">
          <span className="text-xs font-medium text-gray-700 truncate">{config.label}</span>
          <RangePicker 
            picker="month" 
            size="middle" 
            disabledDate={disabledDate}
            onChange={(dates, dateStrings) => onChange(filterKey, formatDateRange(dateStrings))}
            className="text-gray-500 hover:bg-gray-100 text-xs border border-gray-300 max-w-[180px]"
            suffixIcon={false}
            prefix={false}
            placeholder={["start", "end"]}
            format={"MMM-YY"}
          />
        </div>
      )
    default:
      return null;
  }
};